import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export enum LogoMimeType {
  SVG = 'image/svg+xml',
  PNG = 'image/png',
}

export interface Logo {
  mime: LogoMimeType;
  data: string;
  defaultLogo: boolean;
  fileName?: string;
  originalFile?: Logo;
}

@Component({
  selector: 'eop-logo-preview',
  templateUrl: './logo-preview.component.html',
  styleUrls: ['logo-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LogoPreviewComponent {
  @Input()
  logo: Logo;

  get logoIMG() {
    if (!this.logo || !this.logo.mime || !this.logo.data) {
      return null;
    }
    return this._sanitizer.bypassSecurityTrustResourceUrl(
      `data:${this.logo.mime};base64,${this.logo.data}`
    );
  }

  private readonly _sanitizer: DomSanitizer = inject(DomSanitizer);
}
